import { layers, namedFlavor } from '@protomaps/basemaps';
import type { LayerSpecification, StyleSpecification } from 'maplibre-gl';

import { config } from '~/config';

const TILE_URL = `https://api.protomaps.com/tiles/v4/{z}/{x}/{y}.mvt?key=${config.protomaps.apiKey}`;
const GLYPHS_URL =
  'https://protomaps.github.io/basemaps-assets/fonts/{fontstack}/{range}.pbf';
const SPRITE_URL =
  'https://protomaps.github.io/basemaps-assets/sprites/v4/light';

export const mapStyle: StyleSpecification = {
  version: 8,
  name: 'Multiverse Light',
  glyphs: GLYPHS_URL,
  sprite: SPRITE_URL,
  sources: {
    protomaps: {
      type: 'vector',
      tiles: [TILE_URL],
      maxzoom: 15,
    },
  },
  layers: (
    layers('protomaps', namedFlavor('light'), {
      lang: 'en',
    }) as LayerSpecification[]
  ).filter((l) => l.id !== 'pois'),
};
